/** Espelha regra_correspondencia_produto_nfe_entrada: regra que relacionou o item da NF-e de entrada a um produto do cadastro. */
export enum RegraCorrespondenciaProdutoNFeEntradaEnum {
  Ean = 1,
  FornecedorCodigoDescricao = 2,
  FornecedorCodigo = 3,
  CodigoDescricao = 4,
  Descricao = 5,
  Manual = 6,
  SemCorrespondencia = 7,
}
